<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row>
			<v-img contain height="200" :src="require('@/assets/img/fantastikLottery/logo_without_lottery.png')"></v-img>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<v-btn id="see-it-live-btn" @click="scrollToStream">
					See it live
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<h1 class="white--text">
					Latest results
				</h1>
			</v-col>
		</v-row>
		<v-row justify="center" class="mb-5">
			<v-col
				xl="2"
				lg="3"
				md="4"
				sm="6"
				cols="12"
				v-for="(result, index) in results"
				:key="`${result.date}-${result.sortition.id}`"
			>
				<card class="result-card rounded-xl" :class="{'last-winning': index === 0}" :result="result"
							:image-dimensions="$vuetify.breakpoint.smAndDown ? { height:'35px', width: '35px'} : { height:'42px', width: '42px'}"
							:pick-three-image="{ src: require('@/assets/img/fantastikLottery/pick3.png'), width: '90px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/fantastikLottery/pick4.png'), width: $vuetify.breakpoint.smAndDown ? '75px' : '90px', height: '50px', contain: true }">
					<template #sortition-area="{date, sortition}">
						<v-row align="center">
							<v-col cols="12">
								<v-img contain height="120" :src="require('@/assets/img/fantastikLottery/logo_without_lottery.png')"></v-img>
							</v-col>
							<v-col cols="12">
								<h2 class="sortition-name">{{ sortition.name }}</h2>
								<h5 class="mb-0">
									{{ date }}
								</h5>
							</v-col>
						</v-row>
					</template>
				</card>
			</v-col>
		</v-row>
		<v-responsive :aspect-ratio="16 / 9" class="mb-10">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=fantastiklot.tv`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import {generateImageMapFor} from "@homepage/helpers/image";
import Card from "@homepage/components/streams/cards/Card.vue";

export default {
	name: "FantastikLotteryStream",
	components: {
		Card
	},
	extends: BaseStream,
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
		};
	},
};
</script>

<style scoped lang="scss">
@import './common.scss';

.result-card {
	background-color: rgba(0, 0, 0, 0.5);
	box-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black;
	color: white;
}

.sortition-name {
	word-break: keep-all;
}

@keyframes blink-border {
	to {
		box-shadow: 0 0 25px #818181;
	}
}

.last-winning {
	transition: border, box-shadow;
	animation: blink-border 500ms infinite alternate ease;
}
</style>

<style>
#inspire {
	background-image: url("../../../assets/img/fantastikLottery/background.png");
	background-repeat: no-repeat;
	background-size: contain;
}
</style>
